import React, { Component } from 'react'
import { UNEXPECTED_ERROR_MESSAGE } from '../constants/AppConstants'
import ErrorMessage from './form/ErrorMessage'
import { notifyError } from '../utils/Util'

class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  componentDidCatch(error, info) {
    // Display fallback UI
    this.setState({ hasError: true })
    notifyError(error)
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div className="spin-container">
          <div className="center-spin">
            <ErrorMessage errorMessage={UNEXPECTED_ERROR_MESSAGE} />
          </div>
        </div>
      )
    }
    return this.props.children
  }
}

export default ErrorBoundary



// WEBPACK FOOTER //
// ./src/components/ErrorBoundary.js